import React, { useContext } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Form, Header, Segment, Table } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import InfoPopup from '~/components/InfoPopup'
import Fertilizer from './Fertilizer'
import { CoolFarmOptionsContext } from '../../..'

const GrazingFertilizers: React.FC = () => {
  const { t } = useTranslation()
  const { control } = useFormContext()
  const options = useContext(CoolFarmOptionsContext)

  const { fields: fertilizerFields, append: appendFertilizer, remove: removeFertilizer } = useFieldArray({
    control,
    name: 'fertilizers',
    keyName: 'key'
  })

  return (
    <>
      <Header attached='top' block>
        <div style={{ display: 'flex', gap: 5 }}>
          {t('Grassland Fertilisation')}
          <InfoPopup
            content={t(`Enter data on fertiliser application rate per unit of area.
            Note1: You can enter inputs by 'fertiliser weight' or by 'units' of the active ingredient, such as units of N (nitrogen).
            Note2: If there are multiple applications of a unique product in a single month you can aggregate to a single "Fertiliser application". But please create a new "Fertilizer Application" for each month that a product is applied and use the midpoint of the month as the date of application.
            Results will be more accurate if each unique application of a product is recorded separately.`
            )}
            styleIcon={{ fontSize: '1.3em' }}
          />
        </div>
      </Header>
      <Segment attached>
        <div style={{ marginBottom: '1em' }}>{t('Edit Complete this section for the grazing area used by your dairy herd only.')}</div>
        <div style={{ marginBottom: '1em' }}>{t('Enter data on fertiliser application rate per unit of area. Note that you can enter inputs by "fertiliser weight" OR by "units" of the active ingredient, such as units of N (nitrogen).')}</div>
        <div style={{ marginBottom: '1em' }}>{t('If your fertiliser type is not listed, you can compose your own, selecting your own values for active ingredients.')}</div>
        <Form.Group widths={'equal'}>
          <FormFields.Select
            control={control}
            name={'fertilizationApproach'}
            label={t('Fertilization type')}
            rules={{
              required: true
            }}
            withoutAsterisk
            options={options?.fertilizationApproaches?.map(fertApproach => ({ value: fertApproach.key, text: fertApproach.label })) || []}
            placeholder={t('Select fertiliziation approach')}
            noErrorMessage
        />
          <FormFields.Input
            control={control}
            name={'grasslandArea'}
            placeholder={t('in hectars')}
            typeInput='controled'
            suffix=' hectars'
            rules={{
              required: true
            }}
            label={t('Grassland area')}
            withoutAsterisk
            noErrorMessage
        />
        </Form.Group>
        
        {fertilizerFields.map((field, index) => (
          <>
            <Header attached='top' block>
              {index + 1}.
            </Header>
            <Segment attached>
              <Fertilizer
                key={field.key}
                id={field.key}
                index={index}
                removeFertilizer={removeFertilizer}
              />
            </Segment>
          </>
        ))}
        <div style={{ display: 'flex', justifyContent: 'end', marginTop: '1em' }}>
          <Button
            type='button'
            style={{ color: 'white' }}
            icon='plus'
            content={t('Add Fertilizer')}
            onClick={() => appendFertilizer({
              cftIngredientId: null,
              amount: null,
              amountUnit: null,
              cftProductionRegionId: null,
              applicationDate: null,
              emissionsInhibitors: null
            })}
          />
        </div>
      </Segment>
    </>
  )
}
export default GrazingFertilizers